export const STABLECOIN_FEE_POLLING_TIME = 60
